import { useState } from "react";
import {
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Grid,
  makeStyles,
  Box,
} from "@material-ui/core";
import translate from "i18n/translate";
import useRegister from "./useRegister";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import { AUTH_TITLE_SPACE, AUTH_CONTAINER_WIDTH } from "../../../../constants";

const STEP_ONE = 0;
const STEP_TWO = 1;
const STEP_THREE = 2;

const STEPPER_BULLETS_WIDTH = 37;

export const useStyles = makeStyles((theme) => ({
  stepper: {
    padding: 0,
    "& .MuiStepLabel-iconContainer .MuiSvgIcon-root": {
      fill: theme.palette.secondary.main,
    },
    "& .MuiStepLabel-iconContainer .MuiStepIcon-text": {
      fill: theme.palette.primary.contrastText,
    },
  },
  container: {
    maxWidth: AUTH_CONTAINER_WIDTH + STEPPER_BULLETS_WIDTH,
  },
  label: {
    "& .MuiTypography-root": {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(24),
      color: theme.palette.text.primary,
    },
  },
}));

const Register = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(STEP_ONE);
  const { stepOne, stepTwo, stepThree } = useRegister();

  const onGoBack = () => {
    if (activeStep !== 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const onStepOneComplete = async (values, actions) => {
    const isStepValid = await stepOne.onSubmit(values, actions);
    if (isStepValid) {
      setActiveStep(STEP_TWO);
    }
  };

  const onStepTwoComplete = (data) => {
    const isStepValid = stepTwo.onSubmit(data);
    if (isStepValid) {
      setActiveStep(STEP_THREE);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        item
        justifyContent="center"
        spacing={3}
        className={classes.container}
      >
        <Grid container item xs={12} justifyContent="center">
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="h2">
              {translate("auth.createAccount")}
            </Typography>
          </Box>
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Stepper
            className={classes.stepper}
            activeStep={activeStep}
            orientation="vertical"
          >
            <Step>
              <StepLabel className={classes.label}>
                {translate("auth.emailAndPassword")}
              </StepLabel>
              <StepContent>
                <StepOne
                  onSubmit={onStepOneComplete}
                  currentState={stepOne.currentState}
                />
              </StepContent>
            </Step>
            <Step>
              <StepLabel className={classes.label}>
                {translate("auth.personalData")}
              </StepLabel>
              <StepContent>
                <StepTwo
                  onSubmit={onStepTwoComplete}
                  currentState={stepTwo.currentState}
                  setCurrentState={stepTwo.setCurrentState}
                  businessLines={stepTwo.businessLines}
                  onGoBack={onGoBack}
                />
              </StepContent>
            </Step>
            <Step>
              <StepLabel className={classes.label}>
                {translate("auth.address")}
              </StepLabel>
              <StepContent>
                <StepThree
                  onGoBack={onGoBack}
                  onSubmit={stepThree.onSubmit}
                  currentState={stepThree.currentState}
                  setCurrentState={stepThree.setCurrentState}
                />
              </StepContent>
            </Step>
          </Stepper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Register;
